import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faTrash,
  faArrowUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import { useNavigate } from 'app/src/utils/routing';
import * as colors from 'app/src/styles/colors';

import { UPDATE_USER_NOTIFICATION } from './queries';

const Container = styled(View)`
  flex-direction: row;
  margin-bottom: 10px;
`;

const Body = styled(Text)`
  font-weight: ${props => props.viewed ? 400 : 800};
`;

const IconContainer = styled(View)`
  margin-right: 8px;
  margin-left: ${props => props.marginLeft ? '8px' : '0px'};
`;

export const CreatedTime = styled(Text)`
  color: ${colors.iconGray};
`;

const Notification = ({ userNotification, setShowModal }) => {
  const { notification } = userNotification;
  const navigate = useNavigate();

  const [updateUserNotification] = useMutation(UPDATE_USER_NOTIFICATION);

  const toggle = field => {
    updateUserNotification({
      variables: {
        id: userNotification.id,
        [field]: !userNotification[`${field}At`]
      }
    });
  };

  const viewed = !!userNotification.viewedAt;
  const resourcePath = userNotification.notification.resourcePath.
    replace(/\/sellers\/\d+/, '');

  const handleBodyPress = () => {
    if (!viewed) { toggle('viewed'); }
    if (resourcePath) {
      navigate(resourcePath);
      setShowModal(false);
    }
  };

  return (
    <Container>
      <IconContainer>
        <Pressable onPress={() => toggle('viewed')}>
          <FontAwesomeIcon
            icon={faEye}
            style={{color: viewed ? colors.iconGray : colors.elGreen}}
            title="Mark as Read"
          />
        </Pressable>
      </IconContainer>

      <IconContainer>
        <Pressable onPress={() => toggle('hidden')}>
          <FontAwesomeIcon
            icon={faTrash}
            style={{color: colors.elRed}}
            title="Dismiss"
          />
        </Pressable>
      </IconContainer>

      <Pressable onPress={handleBodyPress}>
        <Body viewed={viewed}>
          {notification.body}
          {resourcePath && (
            <IconContainer marginLeft>
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                style={{color: colors.iconGray}}
              />
            </IconContainer>
          )}
        </Body>
        <CreatedTime>
          {moment(notification.createdAt).format('MM-DD-YY \@ hh:mmA')}
        </CreatedTime>
      </Pressable>
    </Container>
  );
};

export default Notification;
